import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props { children: ReactNode }
interface State { error?: Error }

export function isModuleLoadError(error: Error): boolean {
  return /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|loading (?:css )?chunk|unable to preload css/i.test(error.message);
}

export class ToolErrorBoundary extends Component<Props, State> {
  state: State = {};

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Tool failed.', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      const resourceFailed = isModuleLoadError(this.state.error);
      return (
        <div className="tool-fatal" role="alert">
          <strong>{resourceFailed ? '工具资源未能加载' : '这个工具刚才没能完成处理'}</strong>
          <p>{resourceFailed ? '页面版本可能已更新，或网络暂时中断。刷新后重新打开工具；未保存的输入会清空。' : '请重新尝试；若仍然失败，可查看错误详情。'}</p>
          <button className="tool-button tool-button-primary" onClick={() => resourceFailed ? window.location.reload() : this.setState({ error: undefined })} type="button">{resourceFailed ? '刷新并重新加载' : '重新尝试'}</button>
          <details><summary>错误详情</summary><p>{this.state.error.message || '未知错误'}</p></details>
        </div>
      );
    }
    return this.props.children;
  }
}
